import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ToggleButton from "react-toggle-button";
import Api from "../../../Services/Api";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import {HttpStatus, Status} from "../../common/Constants";
import {
    removeNullFields,
    flattenFormGroupObject,
    mapToObjectDDL,
} from "../../common/mapper";
import {formGroup} from "./config";
import MasterSamsatFilter from "./masterSamsatFilter";
import MasterSamsatModifying from "./masterSamsatModifying";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../Services/Utils";

class MasterSamsat extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        },
        {
            name: "samsatId",
            label: "ID",
        },
        {
            name: "samsatName",
            label: "Nama Samsat",
        },
        {
            name: "samsatId",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    const status = this.state.dataTable[rowIndex].status;
                    return (
                        <FlexView
                            vAlignContent="center"
                            style={{justifyContent: "space-between"}}
                        >
                            <ToggleButton
                                value={R.equals(status, Status.ACTIVE)}
                                onToggle={(value) =>
                                    this.handleUpdateStatus(
                                        val,
                                        !value ? Status.ACTIVE : Status.INACTIVE
                                    )
                                }
                            />
                            <SimpleButton
                                category="action_button"
                                className="btnAct"
                                onClick={() => this.handleModifyingVisibility(val)}
                                icon={
                                    <i
                                        className="fa fa-lw fa-pencil-alt"
                                        style={{
                                            backgroundColor: "transparent",
                                            color: "red",
                                            fontSize: 20,
                                        }}
                                    />
                                }
                            />
                            <SimpleButton
                                category="action_button"
                                className="btnAct margin-left-15px"
                                onClick={() => this.handleShowAlert(val)}
                                icon={
                                    <i
                                        className="fa fa-trash"
                                        style={{
                                            backgroundColor: "transparent",
                                            color: "red",
                                            fontSize: 20,
                                        }}
                                    />
                                }
                            />
                        </FlexView>
                    );
                },
                setCellProps: () => ({
                    style: {width: "20%"},
                }),
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            deleteId: "",
            loading: false,
            printVisible: false,
            modifyingVisible: false,
            filterVisible: false,
            filterData: {},
            submittedFilterData: {},
            lastCabang: null,
            selectedData: null,
            pagination: {
                totalData: 1,
                limit: 5,
                page: 1,
            },
            listCabang: [],
            cabangOptions: [],
            dataTable: [],
            isFetch: false,
            alertCannotDelete: false,
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        try {
            const response = await Api.create(
                "NAGAMAS_MASTER_DATA"
            ).findAllMasterCabang();
            let filteredData = [];

            if (response.ok && !R.isEmpty(response.data.data)) {
                const cabangs = response.data.data;
                const allowedCabangs = this.props.menuAccess.map(
                    (data) => data.idRefObj
                );

                filteredData = cabangs
                    .filter((item) => allowedCabangs.includes(item.kodeCabang))
                    .map((c) => mapToObjectDDL(c.namaDealer, c.kodeCabang));

                const defaultCabang = filteredData.length > 0 ? [filteredData[0]] : [];

                await this.setState((prevValue) => ({
                    ...prevValue,
                    cabangOptions: filteredData,
                    listCabang: defaultCabang,
                    lastCabang: defaultCabang,
                }));

                await this.fetchData({
                    listCabang: defaultCabang.map((c) => c.value),
                });
            }
        } catch (error) {
            console.error("Error:", error);
        }
        this.handleTriggerLoading();
    };

    componentDidUpdate = async (_, prevState) => {
        if (
            (prevState.pagination.page !== this.state.pagination.page ||
                prevState.pagination.limit !== this.state.pagination.limit) &&
            !this.state.isFetch
        ) {
            this.handleTriggerLoading();
            let {submittedFilterData, listCabang} = this.state;
            let req = submittedFilterData;
            if (!submittedFilterData?.listCabang || !submittedFilterData?.listCabang?.length > 0) {
                req.listCabang = listCabang?.map(c => c?.value);
            }
            await this.fetchData(
                req,
                this.state.pagination.page,
                this.state.pagination.limit
            );
            this.handleTriggerLoading();
        }
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    refetch = async () => {
        let {submittedFilterData, listCabang} = this.state;
        let req = submittedFilterData;
        if (!submittedFilterData?.listCabang || !submittedFilterData?.listCabang?.length > 0) {
            req.listCabang = listCabang?.map(c => c?.value);
        }
        await this.fetchData(
            req,
            1,
            5
        );
    };

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevValue) => ({...prevValue, isFetch: true}));
        const samsatId =
            !R.isNil(filter) && !R.isNil(filter.samsatId) ? filter.samsatId : null;
        const samsatName =
            !R.isNil(filter) && !R.isNil(filter.samsatName)
                ? filter.samsatName
                : null;
        const listCabang =
            !R.isNil(filter) && !R.isNil(filter.listCabang) ? filter.listCabang : this.state.lastCabang.map(i => i.value);

        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSamsat,
            menuName: "Master Samsat",
            setError: this.props.setError,
            args: {
                listCabang,
                samsatId,
                samsatName,
                page,
                limit,
            },
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data,
                pagination: {
                    ...prevValue.pagination,
                    totalData: res.data.totalData,
                    limit,
                    page,
                },
            }));
        }
        this.setState((prevValue) => ({...prevValue, isFetch: false}));
    };

    handleShowAlert = (id) => {
        if (id) {
            this.setState((prevValue) => ({...prevValue, deleteId: id}));
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                deleteId: "",
            }));
        }
    };

    handleModifyingVisibility = async (id) => {
        this.handleTriggerLoading();
        if (id) {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterSamsatById,
                menuName: "Master Samsat",
                setError: this.props.setError,
                args: id,
            });
            if (
                res.ok &&
                !R.isNil(res.data.data) &&
                res.data.status === HttpStatus.SUCCESS
            ) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: {
                        ...res.data.data,
                        listCabang: res.data.data.listCabang.map((lc) =>
                            mapToObjectDDL(lc.namaCabang, lc.kodeCabang)
                        ),
                    },
                    modifyingVisible: !prevValue.modifyingVisible,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }
        this.handleTriggerLoading();
    };

    handleUpdateStatus = async (id, status) => {
        this.handleTriggerLoading();
        const request = {
            samsatId: id,
            status,
        };
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateMasterSamsatStatus,
            menuName: "Master Samsat",
            setError: this.props.setError,
            args: request,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.refetch();
        }
        this.handleTriggerLoading();
    };

    handlePrint = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            printVisible: !prevValue.printVisible,
        }));
    };

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleSubmitFilter = async () => {
        this.handleTriggerLoading();
        let {filterData} = this.state;
        let listCabang = !R.isNil(filterData.listCabang)
            ? filterData.listCabang.map((kc) => kc.value)
            : [];
        this.setState((prevValue) => ({...prevValue, listCabang: R.isEmpty(listCabang) ? prevValue.lastCabang : []}));
        const request = removeNullFields({
            ...filterData,
            listCabang,
        });
        await this.fetchData(request, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: false,
            submittedFilterData: request,
        }));
        this.handleTriggerLoading();
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleSearch = async () => {
        this.handleTriggerLoading();
        this.setState((prevValue) => ({...prevValue, filterData: {}}));
        const request = removeNullFields({
            listCabang: !R.isNil(this.state.listCabang)
                ? this.state.listCabang.map((kc) => kc.value)
                : [],
        });
        await this.fetchData(request, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: request,
        }));
        this.handleTriggerLoading();
    };

    handleShowAlertCannotDelete = () => {
        this.setState((prevValue) => ({...prevValue, alertCannotDelete: !prevValue.alertCannotDelete}));
    };

    handleSubmitDelete = async () => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteMasterSamsat,
            menuName: "Master Samsat",
            setError: this.props.setError,
            args: this.state.deleteId,
        });
        this.handleShowAlert();
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.refetch();
        } else if (res.data.code === 509) {
            this.handleShowAlertCannotDelete();
        }
        this.handleTriggerLoading();
    };

    handleSubmitModifying = async (controls) => {
        this.handleTriggerLoading();
        const formGroup = flattenFormGroupObject(controls);
        const request = {
            ...formGroup,
            listCabang: !R.isEmpty(formGroup.listCabang)
                ? formGroup.listCabang.map((lkc) => lkc.value)
                : [],
        };
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").modifyMasterSamsat,
            menuName: "Master Samsat",
            setError: this.props.setError,
            args: request,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.refetch();
            await this.handleModifyingVisibility();
        }
        this.handleTriggerLoading();
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    handleCabangChange = async (value) => {
        const selectedCabang = value ? [value] : [];
        await this.setState((prevValue) => ({
            ...prevValue,
            listCabang: selectedCabang,
            lastCabang: selectedCabang,
            pagination: {
                limit: 5,
                page: 1
            }
        }));

        this.handleTriggerLoading();
        try {
            await this.fetchData({
                listCabang: selectedCabang.map((c) => c.value),
            });
        } catch (error) {
            console.error("Error during fetchData:", error);
        }
        this.handleTriggerLoading();
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView
                        style={{justifyContent: "space-between", alignItems: "center"}}
                        className="margin-bottom-20px margin-top-5px"
                    >
                        <FlexView vAlignContent="center">
                            <SimpleDDL
                                id="select_options_nama_cabang_hak_akses"
                                placeholder="Nama Cabang Hak Akses"
                                name="listCabang"
                                box="search"
                                containerclassname="margin-bottom-5px width width-250px"
                                options={this.state.cabangOptions}
                                value={this.state.listCabang[0] || null}
                                onChange={this.handleCabangChange}
                            />
                        </FlexView>
                        <SimpleButton
                            className="btn background-red"
                            category="action_button"
                            onClick={this.handleFilterVisibility}
                            icon={<i className="fa fa-qrcode"></i>}
                        />
                    </FlexView>
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.tableColumns}
                        toCount={this.state.pagination.totalData}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                        options={defaultTableChange(
                            this.handleChangePage,
                            this.handleRowsPerPage
                        )}
                        footerAdditionalButtons={
                            <>
                                <SimpleButton
                                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                                    onClick={() => this.handleModifyingVisibility()}
                                >
                                    Tambah
                                </SimpleButton>
                                <SimpleButton secondary onClick={this.handlePrint}>
                                    Cetak
                                </SimpleButton>
                            </>
                        }
                    />
                </Container>
                {this.state.loading && (
                    <SimpleLoadingOverlay active={this.state.loading}/>
                )}
                {this.state.printVisible && (
                    <SimplePrintTable onClearPrint={this.handlePrint}/>
                )}
                {this.state.deleteId !== "" && (
                    <SimpleAlert
                        visible={this.state.deleteId !== ""}
                        onClickClose={() => this.handleShowAlert()}
                        content={
                            <div>
                                <p>Apakah anda yakin ingin menghapus data Samsat ?</p>
                            </div>
                        }
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton secondary onClick={() => this.handleShowAlert()}>
                                    Batal
                                </SimpleButton>
                                <SimpleButton onClick={() => this.handleSubmitDelete()}>
                                    Iya
                                </SimpleButton>
                            </FlexView>
                        }
                    />
                )}
                {this.state.filterVisible && (
                    <MasterSamsatFilter
                        state={this.state}
                        onSetState={this.handleStateChange}
                        onClickClose={this.handleFilterVisibility}
                        onSubmit={this.handleSubmitFilter}
                    />
                )}
                {this.state.modifyingVisible && (
                    <MasterSamsatModifying
                        formGroup={formGroup}
                        initialValues={this.state.selectedData}
                        visible={this.state.modifyingVisible}
                        onSubmit={this.handleSubmitModifying}
                        onClickClose={() => this.handleModifyingVisibility()}
                    />
                )}
                {this.state.alertCannotDelete && (
                  <SimpleAlert
                    visible={this.state.alertCannotDelete}
                    onClickClose={() => this.handleShowAlertCannotDelete()}
                    content={
                        <div>
                            <p>Data tidak dapat dihapus, sudah masuk kedalam transaksi.</p>
                        </div>
                    }
                    additionalButtons={
                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                            <SimpleButton onClick={() => this.handleShowAlertCannotDelete()}>
                                OK
                            </SimpleButton>
                        </FlexView>
                    }/>
                )}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterSamsat);
